import { useState } from 'react';

/**
 * Local page navigation using React state instead of URL query parameters.
 * Use this for pages with multiple tables to avoid pagination state conflicts.
 */
export default function useLocalPageNavigation() {
  const [currentPage, setCurrentPage] = useState(1);

  const navigateToPage = (page: number) => {
    setCurrentPage(page);
  };

  return { currentPage, navigateToPage };
}
